import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    gradeId:'',
    courseId:'',
    classId:'',
    search:[],
    index:'',//视频包视频详情
    info:[],
    mineInfo:'',//完善信息弹框
  },
  mutations: {
    getGrade(state,date) {
      state.gradeId = date;
    },
    getCourse(state,date){
      state.courseId = date;
    },
    getClass(state,date){
      state.classId = date;
    },
    getSearch(state,date){
      state.search = date;
    },
    getIndex(state,date){
      state.index = date;
    },
    getMineInfo(state,date){
      state.mineInfo = date;
    },
    getLocalStorage(state,date){
      localStorage.setItem('info',date);
      state.info = date;
    },
    delLocalStorage(state,date){
      localStorage.removeItem('info');
      state.info = date;
    }
  },
  
})


// WEBPACK FOOTER //
// ./src/store/index.js